import { HttpInterceptorFn } from "@angular/common/http";

/**
 * Reject any outgoing HTTP request that targets an http:// URL. Per the
 * HIPAA-adjacent security rules, every backend call must travel over
 * TLS. Throwing here surfaces the misconfigured URL at development
 * time rather than silently leaking request contents in plain text.
 */
export const httpsEnforceInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith("http://")) {
    throw new Error(`Insecure HTTP request blocked: ${req.url}`);
  }
  return next(req);
};
